import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { usePDF } from '@react-pdf/renderer';
import PDFTerm from './PDFTerm';
import { format } from 'date-fns';
import { Col, Spin } from 'antd';
import { Row, VertButton, message } from '@vertem-core/vertice-ds';
import ModalApprove from './VertModalAprove';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';
import { useNavigate } from 'react-router';

const GeneratePDFTerm = ({
  user,
  data,
  headers,
  quote,
  products,
  cancelApprove,
  createPDF,
  isLoading,
  spot,
  ...props
}) => {
  const config = {
    headers: {
      ...headers,
    },
  };

  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  const [instance] = usePDF({
    document: (
      <PDFTerm
        spot={spot}
        data={data}
        quote={quote}
        products={products}
        description={description}
      />
    ),
  });

  const uploadTerm = (file, values) => {
    const formData = new FormData();

    formData.append(
      'file',
      file,
      `TERMO_${format(new Date(), 'dd/MM/yyyy_hh:MM:ss')}.pdf`
    );

    setIsVisible(false);

    setLoading(true);

    redemptionsApiClient
      .post('/RedemptionFile/Upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...config.headers,
        },
      })
      .then((res) => {
        approveSpot(
          {
            url: res.data.url,
          },
          values
        );
      })
      .catch((err) => {
        message.error('Erro ao enviar o termo');

        setLoading(false);
      });
  };

  const approveSpot = async ({ url }, values) => {
    const _data = {
      redemptionId: spot.id,
      description: values.description,
      status: 4,
      termUrl: url,
    };

    redemptionsApiClient
      .put(`/Redemption/Approve`, _data, config)
      .then((res) => {
        message.success('Solicitação aprovada com sucesso!');
        navigate('/list-redemptions', {
          state: {
            spotApproved: true,
            spotId: data.id,
          },
        });
      })
      .catch((err) => {
        message.error(
          'Não foi possível aprovar a solicitação, valide as informações e tente novamente.'
        );
      });
  };

  return (
    data &&
    quote &&
    products &&
    !instance.loading &&
    !instance.error && (
      <Fragment>
        <Col xs={24} sm={12} md={8} lg={6}>
          <VertButton
            type="highlight"
            disabled={loading || instance.loading}
            className="button-view-redemption"
            loading={loading || instance.loading}
            onClick={() => setIsVisible(true)}
          >
            Aprovar Solicitação
          </VertButton>
        </Col>

        {isVisible && (
          <ModalApprove
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            submitApprove={(valuesModal) => {
              uploadTerm(instance.blob, valuesModal);
            }}
            quote={quote}
          />
        )}
      </Fragment>
    )
  );
};

GeneratePDFTerm.propTypes = {
  profile: PropTypes.object,
  user: PropTypes.object,
};

export default GeneratePDFTerm;
